//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
     props:{
        //业务数据
        record:{type:Object,default: () => ({})},
        //流程数据
        process:{type:Object,default: () => ({})},
        //规则绑定
        rules:{type: Object,default: () => ({})},
        //自定义的参数
        config: {type: Object, default: () => ({})},
        //是否不需要session
        passtoken:{type:Boolean,default:false}
    },
    data(){
         return{
             //外网下拉框获取选项
            apiUrl: "onboarding/getSelectOption",
            //后缀
            suffixList:[],
            //国籍
            nationalityList:[],
            pickerOptions: {
              disabledDate(time) {
                return time.getTime() > Date.now();
              }
            }
        }
    },
    methods:{
       checkChange(type,e){ //申请表格单选
            if(type === '1'){
              this.record.peraddress.addrtype = [];
              this.record.peraddress.addrtype.push(e);
            }else if(type === '2'){
              this.record.curraddress.addrtype = [];
              this.record.curraddress.addrtype.push(e);
            }
        },
        /**
         * 初始化下拉框
         */
        initSelect(){
          let p_suffix = {
              showcode:'suffixList',
              selectcode:'SYS_CDFCODECONFIG',
              hasnull:false,
              paras:{"paras0":"SUFFIX","paras1":"1"}
          };
          let p_nationality = {
              showcode:'nationalityList',
              selectcode:'SYS_BNATIONALITY',
              hasnull:false,
              paras:{}
          };
           
          let params = [];
          params.push(p_suffix);
          params.push(p_nationality);
          this.initDropDownWithUrl(this,params,this.apiUrl);
        },
        /**
         * 发送邮件
         */
        async sendmail(){
          let url  = "api/api/genEmailCode";
          let flag = true;
          //校验邮箱不能为空
          if(!this.record.email ||this.record.email === ''){
              this.tipDefault("Please Enter Email Address First");
              flag =  false;
              return flag;
          }else{
            //校验邮箱是否符合规范
            let mail = this.record.email;
            let reg=/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/; 
            if(!reg.test(mail)){
              this.tipDefault("Wrong Email Address Format");
              flag = false;
               return flag;
            }
          }
          if(flag){
            let params = {
              email: this.record.email
            };
            await this.axios.post(url, params).then(({ data }) => {
                let json  = data.data;
                let code  =  json.code;
                if(code === "1"){
                    this.tipSuccess("Email Verification Code Sent Successfully");
                }else{
                    this.tipError("Failed To Send Email Verification Code");                    
                }
            });
          }
        }
    },
    created(){
        this.initSelect();
    },
}



// WEBPACK FOOTER //
// ./src/pcpage/hr/recruitment/resumeApply/staffInfo.vue